<template>
  <div>
    <el-button
      :disabled="$store.getters.tallyLock"
      class="c-background"
      style="background-color: rgb(0, 140, 0)"
      @click="deskClick"
    >
      <span style="color: #fff">&nbsp;工作台</span>
    </el-button>
    <el-button v-if="deskNo" type="info" disabled>{{ deskNo }}</el-button>
  </div>
</template>
<script>
import { trimString } from "@/tool/helper.js";
import { cookieCacheGet, cookieCacheSet } from "@/tool/cache.js";

export default {
  name: "YsWorkDesk",
  model: {
    prop: "deskNo",
    event: "input",
  },
  props: {
    /**
     * 工作台编号
     */
    deskNo: {
      type: String,
      default: "",
    },
    /**
     * 是否初始化时，就绑定工作台
     */
    init: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.init) {
      this.initDeskNo();
    }
  },
  methods: {
    initDeskNo() {
      const deskNo = cookieCacheGet("deskNoCheck");
      if (!deskNo) {
        this.deskClick();
      } else {
        this.$emit("input", deskNo);
      }
    },
    deskClick() {
      this.$prompt("", "工作台", {
        confirmButtonText: "确定",
      })
        .then(({ value }) => {
          this.verifyDeskNo(value);
        })
        .catch(() => {
          if (!this.deskNo) {
            this.deskClick();
          }
        });
    },
    verifyDeskNo(value) {
      const val = trimString(value).toUpperCase();
      if (!val) {
        this.deskClick();
        this.$message.e("请输入工作台号");
      }
      if (Object.keys(val).length !== 8) {
        this.deskClick();
        this.$message.e("工作台号码有误,请检查");
      }
      this.$http
        .post("/erp/Tally/verifyDeskNo", { desk_no: val })
        .then((res) => {
          if (`${res.data.code}` !== "200") {
            this.deskClick();
            this.$message.e(res.data.msg);
          }
          cookieCacheSet("deskNoCheck", val, 64800);
          this.$emit("input", val);
        })
        .catch(this.$noop);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/YsComponents/YsWorkDesk.vue